import { render, staticRenderFns } from "./globalPopUP.vue?vue&type=template&id=e98a48ac&scoped=true"
import script from "./globalPopUP.vue?vue&type=script&lang=js"
export * from "./globalPopUP.vue?vue&type=script&lang=js"
import style0 from "./globalPopUP.vue?vue&type=style&index=0&id=e98a48ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98a48ac",
  null
  
)

export default component.exports